import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://250d72414b9146518642f96d3ade5e02@o4509164176932864.ingest.de.sentry.io/4509164181127248",
  integrations: [],
});
